import { EmojiServiceResponse } from '@atlaskit/emoji/types';
import emojis from '../../../assets/standard-emoji.json';

export const getStandardEmojiData = (): EmojiServiceResponse =>
  emojis as EmojiServiceResponse;
